var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditGrey({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2203_2415)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.33337 2.66666H2.66671C2.31309 2.66666 1.97395 2.80713 1.7239 3.05718C1.47385 3.30723 1.33337 3.64637 1.33337 3.99999V13.3333C1.33337 13.6869 1.47385 14.0261 1.7239 14.2761C1.97395 14.5262 2.31309 14.6667 2.66671 14.6667H12C12.3537 14.6667 12.6928 14.5262 12.9428 14.2761C13.1929 14.0261 13.3334 13.6869 13.3334 13.3333V8.66666",
    stroke: "#2C303B",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3334 1.66669C12.5986 1.40147 12.9583 1.25247 13.3334 1.25247C13.7084 1.25247 14.0682 1.40147 14.3334 1.66669C14.5986 1.9319 14.7476 2.29161 14.7476 2.66669C14.7476 3.04176 14.5986 3.40147 14.3334 3.66669L8.00004 10L5.33337 10.6667L6.00004 8.00002L12.3334 1.66669Z",
    stroke: "#2C303B",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2203_2415"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditGrey);
export default __webpack_public_path__ + "static/media/edit-grey.077ad1b834485f7596670ac6d511f7cb.svg";
export { ForwardRef as ReactComponent };